<script>
import Map from '@/components/Map-New.vue'
import Multiselect from "vue-multiselect";

/**
 * Crypto ICO-landing page
 */
export default {
  components: { Map},
  data() {
    return {
      apiView: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      url: `${process.env.VUE_APP_API_URL}filesminio/view`,
      totalRows: 1,
      numberOfElement: 1,
      perPage: 9,
      currentPage: 1,
      sortDesc: true,
      model: null,
      menu : null,
      filterOn: [],
      isArray : true,
      pageOptions: [5,10,25,50,100],
      menuName : " ",
    };
  },
  computed: {

  },
  watch: {
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
  },
  methods: {

  },
};
</script>

<template>
        <div class="">
            <Map></Map>
        </div>
</template>
<style>

.map{
    margin-top: 50px;
}
</style>
